var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ips avatar",class:_vm.circleClass,style:(_vm.circleStyles)},[(!_vm.hasImage)?_c('span',{staticClass:"initials",style:(_vm.initialsStyles)},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }